module.exports = __webpack_public_path__ + "static/media/089-pause.5ed27fea.svg";